export default class Tabs {
    constructor($el) {
        this.$el = $el;
        this.$$tab = this.$el.querySelectorAll('[role="tab"]');
        this.$activeTab = this.$$tab[0];

        this.initListeners();
        this.updateHighlight();

        requestAnimationFrame(() => {
            this.$el.classList.add('animates');
        });
    }

    initListeners() {
        this.$$tab.forEach($tab => {
            $tab.addEventListener('click', e => {
                this.$$tab.forEach($tab => {
                    $tab.removeAttribute('aria-selected');
                });

                this.$activeTab = e.currentTarget;
                this.$activeTab.setAttribute('aria-selected', 'true');
                this.updateHighlight();

                e.currentTarget.dispatchEvent(
                    new CustomEvent('tabs-change', {
                        bubbles: true,
                        detail: {
                            tab: e.currentTarget,
                        },
                    })
                );
            });
        });

        window.onload = () => {
            this.updateHighlight();
        };

        setInterval(() => {
            this.updateHighlight();
        }, 100);
    }

    updateHighlight() {
        const baseX = this.$$tab[0].getBoundingClientRect().x;
        const highlightWidth = this.$activeTab.getBoundingClientRect().width;
        const highlightX = this.$activeTab.getBoundingClientRect().x - baseX;

        this.$el.style.setProperty('--highlight-width', `${highlightWidth}px`);
        this.$el.style.setProperty('--highlight-x', `${highlightX}px`);
    }
}
